import React from 'react';
import './Contact.css';

class Contact extends React.Component {
  render() {
    return (
        <div className="contact">
            <div>
                <h2 className="contact-h2">Kontakt:</h2>
                <p>E-Mail: red-lines@googlegroups.com</p>
                <p>Telefon: +49 171 2914642</p>
            </div>
        </div>
    )
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact/Contact.js